import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({
    title = 'Aamy Tours Sri Lanka - Discover the Pearl of the Indian Ocean',
    description = 'Experience the real Sri Lanka with Aamy Tours Sri Lanka. Personalized tour packages, wildlife safaris, cultural journeys, beach holidays, adventure activities, and authentic local experiences across the island.',
    keywords = 'Aamy Tours Sri Lanka, Sri Lanka Tours, Travel Sri Lanka, Tour Packages Sri Lanka, Wildlife Safari, Cultural Tours, Beach Holidays, Adventure Tours, Ayurveda Sri Lanka, Private Tours Sri Lanka, Luxury Travel Sri Lanka, Family Holidays Sri Lanka',
    image = '%PUBLIC_URL%/logo.jpg', // Keep your new logo path here (update in public folder if needed)
    url = 'https://aamytours.com',
}) => {
    return (
        <Helmet>
            {/* Basic Meta Tags */}
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            <meta name="author" content="Aamy Tours Sri Lanka" />
            <meta name="robots" content="index, follow" />
            <link rel="canonical" href={url} />

            {/* Open Graph / Facebook */}
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />
            <meta property="og:url" content={url} />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="Aamy Tours Sri Lanka" />
            <meta property="og:locale" content="en_US" />

            {/* Twitter Card */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />
            <meta name="twitter:site" content="@AamyToursSL" /> {/* Optional: update if you have Twitter */}
            <meta name="twitter:creator" content="@AamyToursSL" />

            {/* Favicon (optional - update if you have new ones) */}
            {/* <link rel="icon" href="%PUBLIC_URL%/favicon.ico" /> */}
        </Helmet>
    );
};

export default SEO;